// extracted by mini-css-extract-plugin
module.exports = {"nav-button":"profile-button_nav-button__q74DH","active":"profile-button_active__PMHaJ","user-icon":"profile-button_user-icon__KD_Lo"};